import { executeGetRequest, executePostRequest, FetchConfig } from '@api/client';
import { createFetchCachedLookupPath, createFetchLookupPath, createRefreshLookupPath } from '@routing/apiUrls';
import { FetchLookupResponse } from '@models/lookup/FetchLookup';

type Params = {
    [key: string]: string;
};

export const fetchLookup = async (lookup: string, params: Params, caching = false, config?: FetchConfig) => {
    const getLookupPath = caching ? createFetchCachedLookupPath : createFetchLookupPath;
    const result = await executeGetRequest<FetchLookupResponse>(getLookupPath(lookup, params), config);
    const redirectCacheUrl = result.data?.redirect;

    if (!redirectCacheUrl) return result.data;
    const cachedResult = await executeGetRequest<FetchLookupResponse>(redirectCacheUrl, {
        ...config,
    });
    return cachedResult.data;
};

export const refreshLookup = async (documentId: number, fieldName: string, key: string, config?: FetchConfig) => {
    const result = await executePostRequest<FetchLookupResponse>(createRefreshLookupPath(documentId, fieldName, key), {}, config);
    return result.data;
};
